import { Box, Button, Icon, Paragraph } from '@zillow/constellation-10';
import { IconCheckmarkCircleFilled } from '@zillow/constellation-icons';

import Modal from '@common/components/ConstellationV10Modal';
import userPersonas from '@common/constants/userPersonas';

interface Props {
  goToDashboard: (tenantFirstName: string) => void;
  tenantFirstName: string;
}

const PostConfirmationPage = ({ tenantFirstName = 'your tenant', goToDashboard }: Props) => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      onRequestClose={() => goToDashboard(tenantFirstName)}
      header="Payment setup"
      body={
        <Box
          css={{
            display: 'grid',
            textAlign: 'center',
            gridTemplateRows: 'auto',
            gap: 'default',
          }}
        >
          <Box>
            <Icon
              size="xl"
              css={{
                color: 'green.400',
              }}
            >
              <IconCheckmarkCircleFilled />
            </Icon>
          </Box>
          <Paragraph textStyle="body-lg-bold">Payments successfully set up</Paragraph>
          <Paragraph>
            {`We notified ${tenantFirstName} that you're collecting payments online. You may also want to remind ${tenantFirstName} to complete setup to avoid delays.`}
          </Paragraph>
          <Paragraph>
            Payments made during the initial setup period may take up to five business days to be deposited. Future
            payments are typically deposited within two business days.
          </Paragraph>
        </Box>
      }
      footer={
        <Button emphasis="filled" onClick={() => goToDashboard(tenantFirstName)}>
          Go to payments dashboard
        </Button>
      }
    />
  );
};

export default PostConfirmationPage;
